import React, { useState, useEffect, useRef } from "react";
import {  DropdownButton, Dropdown } from 'react-bootstrap-v5'
import { useHistory } from "react-router";
import { RiArrowDownSLine } from 'react-icons/ri'
import {  MdEdit } from "react-icons/md";
import { productServices } from "../../Services";
import { Modal } from "../../Components";
import ReactPaginate from "react-paginate";
import Loader from "../../Components/Loader";
import { toast } from "react-toastify";
import { BiExport, BiImport } from "react-icons/bi";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../Function/CheckAccess";
// import ReactTooltip from 'react-tooltip';

let currentPage1 = 1;
const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;
export const ProductList = () => {
  const history = useHistory();
  const imgRef = useRef();
  const [listData, setListData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);
  const [loader, setLoader] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);


  const location = useLocation()
  let user_type = localStorage.getItem("user_type")
  // const [show, setShow] = useState(false);
  // const showDropdown = (e) => {
  //   setShow(!show);
  // }
  // const hideDropdown = (e) => {
  //   setShow(false);
  // }


  useEffect(() => {
    getItemList();
    // eslint-disable-next-line
  }, [currentPage]);

  const getItemList = () => {
    let param = { ...pagination, page: currentPage };
    if (pagination.search) {
      param["page"] = 1;
    }
    productServices.getProduct(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setListData(res.data);
        // console.log(res.data,'dataa')
        setPagination({ ...pagination, ...res.pagination });
      } else {
        setLoader(false);
      }
    });
  };

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  const onModalSubmit = () => {
    let postData = {
      id: isModalOpen._id,
      product_status:
        isModalOpen.product_status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
    };

    productServices.updateProductStatus(postData).then((res) => {
      if (res.status) {
        setIsModalOpen(false);
        setIsDeleteOpen(false);
        getItemList();
      }
    });
  };

  const onDeleteSubmit = () => {
    let postData = {
      id: isDeleteOpen._id,
      is_delete: "YES",
    };

    productServices.deleteProduct(postData).then((res) => {
      if (res.status) {
        setIsDeleteOpen(false);
        getItemList();
      }
    });
  };

  const onClickExport = () => {
    productServices.exportProductData().then((res) => {
      if (res.status) {
        window.location.href = REACT_APP_API_BASEURL + "/" + res.data;
        toast.success("file download successfully");
      } else {
        toast.error(res.message);
      }
    });
  };

  const onClickImport = (e) => {
    const formData = new FormData();
    formData.append("csv_file", e.target.files[0]);
    productServices.importProductData(formData).then((res) => {
      if (res.status) {
        toast.success("file upload successfully");
      } else {
        toast.error(res.message);
      }
    });
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-3">
              <div className="d-flex justify-content-between mb-3">
                <div className="input-group pl-3 mx-2">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="search..."
                    onChange={(e) =>
                      setPagination({ ...pagination, search: e.target.value })
                    }
                    onKeyPress={(e) => e.key === "Enter" && getItemList()}
                    onKeyUp={(e) =>
                      e.key === "Backspace" &&
                      pagination.search.length <= 0 &&
                      getItemList()
                    }
                  ></input>
                  <div className="input-group-prepend">
                    <button
                      className="input-group-text pointer search-btn"
                      onClick={() => getItemList()}
                      style={{ backgroundColor: "#e5e4ec" }}
                    >
                      search
                    </button>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end mb-3">
                <div>
                  <input
                    type="file"
                    id="upload"
                    accept=".csv"
                    hidden
                    onChange={(e) => onClickImport(e)}
                  />
                  <label
                    for="upload"
                    className="btn btn-danger waves-effect waves-light mx-1 my-0"
                  >
                    <BiExport />
                    Upload File
                  </label>
                </div>
                <button
                  className="btn btn-success waves-effect waves-light mx-1 my-0"
                  onClick={() => onClickExport()}
                >
                  <BiImport />
                  Download File
                </button>
                {
                  (CheckAccess(223,"add") ||  user_type === "SUPERADMIN" )&& 
                <button
                  className="btn btn-primary w-sm waves-effect waves-light mx-3 my-0"
                  onClick={() => history.push("/add-product")}
                >
                  Add Product
                </button>
                }
              </div>
              <input ref={imgRef} type="file" className="d-none" />
            </div>
            {/* <div className="d-flex justify-content-between mb-3">
                            <div className="d-flex justify-content-between mb-3">
                                <div className="input-group pl-3 w-25">
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="search..."
                                        onChange={(e) => setPagination({ ...pagination, search: e.target.value })}
                                        onKeyPress={(e) => e.key === 'Enter' && getItemList()}
                                        onKeyUp={(e) => ((e.key === 'Backspace') && (pagination.search.length <= 0)) && getItemList()}
                                    ></input>
                                    <div className="input-group-prepend">
                                        <button className="input-group-text pointer search-btn" onClick={() => getItemList()} style={{ backgroundColor: '#e5e4ec' }}>
                                            search
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mb-3">
                                <div>
                                    <input
                                        type="file"
                                        id="upload"
                                        accept=".csv"
                                        hidden
                                        onChange={(e) => onClickImport(e)}
                                    />
                                    <label
                                        for="upload"
                                        className="btn btn-danger waves-effect waves-light mx-1 my-0"
                                    >
                                        <BiExport />
                                        Import File
                                    </label>
                                </div>
                                <button className="btn btn-success waves-effect waves-light mx-1 my-0"
                                // onClick={() => onClickExport()}
                                >

                                    <BiImport />
                                    Export File
                                </button>
                                <button className="btn btn-primary btn-sm w-sm waves-effect waves-light"
                                    onClick={() => history.push('/add-product')}
                                >Add Product
                                </button>
                            </div>

                        </div> */}


            <div className="table-responsive pt-3">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.ddd</th>
                    <th>Product Name</th>
                    <th>Product Gross Weight</th>
                    <th>Product Volume</th>
                    <th>
                      Product Dimentions <br />
                      (Length X Width X Height)
                    </th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {listData &&
                    listData.length > 0 &&
                    listData.map((list, key) => (
                      <tr key={key}>
                        <td className="text-body fw-bold">
                          {(pagination.page - 1) * pagination.limit + (key + 1)}
                        </td>
                        <td>{list.product_name}</td>
                        <td>{list.product_gross_weight}</td>
                        <td>{list.product_gross_volume}</td>

                        {list && list.product_dimentions && Array.isArray(list.product_dimentions) ? (
                          <td className="openTooltip d-flex align-items-center flex-row-reverse justify-content-end">
                        
                            {list.product_dimentions.length > 1 ?
                              <DropdownButton

                                id="dropdown-basic-button" className="linkDrop" title={<RiArrowDownSLine />}>

                                {
                                  list.product_dimentions.map((item, i) => {
                                    return (
                                      <Dropdown.Item href="#/action-1">{i + 1}. {item.length}X{item.width}X{item.height}</Dropdown.Item>

                                    )
                                  })
                                }
                              </DropdownButton>
                              : ''}
                            &nbsp;&nbsp;
                            <div>
                              {
                                list &&
                                list.product_dimentions[0].length +
                                " X " +
                                list.product_dimentions[0].width +
                                " X " +
                                list.product_dimentions[0].height
                              }
                            </div>
                          </td>
                        ) : (
                          <td className="openTooltip d-flex align-items-center flex-row-reverse justify-content-end">
                          <div>
                              {
                                list &&
                                list.product_dimentions[0] +
                                " X " +
                                list.product_dimentions[0] +
                                " X " +
                                list.product_dimentions[0]
                              }
                            </div>
                          </td>
                        )}

                        <td>
                          <span
                            className={
                              "badge rounded-pill font-size-12 pointer" +
                              (list.product_status === "ACTIVE"
                                ? " bg-success"
                                : " bg-soft-danger")
                            }
                            onClick={() => setIsModalOpen(list)}
                          >
                            {list.product_status ? list.product_status : "NA"}
                          </span>
                        </td>

                        <td>
                          {(list.product_dimentions.length > 1 &&  (CheckAccess(223,"edit")) ||  user_type === "SUPERADMIN") ? "" : 
                            <MdEdit
                              className="pointer"
                              onClick={() =>
                                history.push("/edit-product?id=" + list._id, list)
                              }
                              color="#0323fe"
                              size="25px"
                            />
                          }
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {listData.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}
            </div>
          </div>
          {listData.length > 0 && pagination.totalRecord > pagination.limit && (
            <ReactPaginate
              previousLabel={
                <img src="assets/images/prev.svg" height={15} alt="not found" />
              }
              forcePage={currentPage - 1}
              nextLabel={
                <img src="assets/images/next.svg" height={15} alt="not found" />
              }
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={(e) => onPageChangeEvent(e)}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          )}
          {Boolean(isModalOpen) && (
            <Modal.ChangeStatus
              isOpen={Boolean(isModalOpen)}
              title="Update Status"
              message={`Are you sure want to ${isModalOpen.product_status === "ACTIVE" ? "Inactive" : "Active"
                } status ?`}
              onSubmitEvent={() => onModalSubmit()}
              handleClose={() => setIsModalOpen(false)}
            />
          )}
          {Boolean(isDeleteOpen) && (
            <Modal.DeleteItem
              isOpen={Boolean(isDeleteOpen)}
              title="Delete"
              message={`Are you sure want to Delete`}
              onSubmitEvent={() => onDeleteSubmit()}
              handleClose={() => setIsDeleteOpen(false)}
            />
          )}
        </div>
        <Loader isShow={loader} />
      </div>
    </div>
  );
};
